"use client"

import { useState, useEffect } from "react"
import { Link, useLocation } from "react-router-dom"
import "./NavBar.css"

const NavBar = () => {
  const [activeTab, setActiveTab] = useState("Home")
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const pathname = location.pathname
    const tabMap = {
      "/": "Home",
      "/aboutus": "About",
      "/services": "Services",
      "/blogs": "News",
      "/gallery": "Gallery",
      "/contact": "Contact",
      "/usefullinks": "UsefulLinks",
    }
    setActiveTab(tabMap[pathname] || "Home")
    setIsMenuOpen(false) // Close menu on route change
  }, [location])

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const handleTabClick = (tabName) => {
    setActiveTab(tabName)
    setIsMenuOpen(false)
  }

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <nav className={`navbar navbar-expand-lg navbar-light ${isScrolled ? "navbar-scrolled" : ""}`}>
      <div className="container-fluid">
        <div className="logo">
          <Link to="/" onClick={() => handleTabClick("Home")}>
            <img src="../images/logo_new.png" className="fade-rounded-image" alt="Dr. Sunil Apsingi Logo" />
          </Link>
        </div>
        <button
          className={`navbar-toggler ${isMenuOpen ? "active" : ""}`}
          type="button"
          onClick={toggleMenu}
          aria-controls="navbarSupportedContent"
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`} style={{"justify-content": "space-around"}} id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto">
            <li className={`nav-item ${activeTab === "Home" ? "active" : ""}`}>
              <Link className="nav-link" to="/" onClick={() => handleTabClick("Home")}>
                Home
              </Link>
            </li>
            <li className={`nav-item ${activeTab === "About" ? "active" : ""}`}>
              <Link className="nav-link" to="/aboutus" onClick={() => handleTabClick("About")}>
                About
              </Link>
            </li>
            <li className={`nav-item ${activeTab === "Services" ? "active" : ""}`}>
              <Link className="nav-link" to="/services" onClick={() => handleTabClick("Services")}>
                Services
              </Link>
            </li>
            <li className={`nav-item ${activeTab === "News" ? "active" : ""}`}>
              <Link className="nav-link" to="/blogs" onClick={() => handleTabClick("News")}>
                Blogs
              </Link>
            </li>
            <li className={`nav-item ${activeTab === "Gallery" ? "active" : ""}`}>
              <Link className="nav-link" to="/gallery" onClick={() => handleTabClick("Gallery")}>
                Gallery
              </Link>
            </li>
            <li className={`nav-item ${activeTab === "Contact" ? "active" : ""}`}>
              <Link className="nav-link" to="/contact" onClick={() => handleTabClick("Contact")}>
                Contact Us
              </Link>
            </li>
            <li className={`nav-item ${activeTab === "UsefulLinks" ? "active" : ""}`}>
              <Link className="nav-link" to="/usefullinks" onClick={() => handleTabClick("UsefulLinks")}>
                Useful Links
              </Link>
            </li>
            <li className="nav-item nav-cta">
              <Link className="btn btn-appointment" to="/bookappointment">
                Book Appointment
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}

export default NavBar
